import { ArrowRight, KeyRound, ShieldCheck } from "lucide-react";
import { useState, type FormEvent } from "react";
import { Navigate } from "react-router-dom";
import { Button, Spinner } from "../components/Ui";
import { BrandLockup } from "../components/Brand";
import { useAuth } from "../lib/auth";

export function LoginPage() {
  const { user, login } = useAuth();
  const [username, setUsername] = useState("admin");
  const [password, setPassword] = useState("123456");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  if (user) return <Navigate to="/" replace />;

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(username, password);
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : "登录失败");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-page">
      <section className="login-story">
        <BrandLockup context="login" />
        <div className="login-kicker">INSTITUTIONAL PORTFOLIO INTELLIGENCE</div>
        <h1>把宏观变化，<br />翻译成组合动作。</h1>
        <p>从环境判断、配置方案、组合约束到投委会确认，每个结论都保留证据、分歧和决策记忆。</p>
        <div className="login-feature"><ShieldCheck size={19} /><span><strong>人在回路</strong>AI 提供研究与方案，投资经理最终确认。</span></div>
        <div className="login-feature"><KeyRound size={19} /><span><strong>研究可追溯</strong>判断、证据、约束与复盘形成闭环。</span></div>
      </section>
      <section className="login-panel">
        <form onSubmit={submit} className="login-form">
          <div className="login-form-head"><span>安全访问</span><small>WYX · ALPHAOS</small></div>
          <h2>登录研究工作台</h2>
          <p>使用管理员账号进入机构演示环境。</p>
          <label>账号<input autoComplete="username" value={username} onChange={(event) => setUsername(event.target.value)} /></label>
          <label>密码<input type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} /></label>
          {error && <div className="form-error">{error}</div>}
          <Button type="submit" disabled={busy} className="login-button">{busy ? <Spinner label="验证中" /> : <>进入智能投研系统 <ArrowRight size={16} /></>}</Button>
          <div className="demo-credential"><span>演示账号</span><code>admin</code><span>密码</span><code>123456</code></div>
        </form>
      </section>
    </div>
  );
}
